module.exports = __webpack_public_path__ + "media/images/magic_modules/homepage_grid_module/hgm_pattern-0-747b5b041fc91f7b93d75977d9cdab28.png";